'use strict';

var util = require('./util');
module.exports = SchemaObject;
function SchemaObject(obj) {
  util.copy(obj, this);
}